<template>
  <AppLink :to="url">
    <slot />
  </AppLink>
</template>

<script setup lang="ts">
defineProps<{
  url: string
}>()
</script>
